import React from 'react';

const CarouselArrow = ({className}) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 40.569 40.568">
    <path d="M1657.942,17701.627a20.283,20.283,0,1,1,14.341,5.941A20.168,20.168,0,0,1,1657.942,17701.627Zm-4.391-14.34a18.734,18.734,0,1,0,18.732-18.736A18.754,18.754,0,0,0,1653.551,17687.287Zm16.483,5.367a1.035,1.035,0,0,1,0-1.471l4.315-4.381-4.426-4.379a1.035,1.035,0,0,1,0-1.471,1.049,1.049,0,0,1,1.475,0l5.151,5.168a1.043,1.043,0,0,1,.036,1.436l-5.079,5.094a1.04,1.04,0,0,1-1.471,0Z" transform="translate(-1652 -17667)"/>
  </svg>
);

export default CarouselArrow;
